import { DATE_FORMAT } from "helpers/common";
import React from "react";

const Columns = ({ onCliclNavigate, currentPage, pageSize }) => [
  {
    dataField: "",
    text: "SrNo",
    formatter: (cell, row, rowIndex) => (
      <span className="text-capitalize cursor-pointer hover-lightblue">
        {(currentPage - 1) * pageSize + (rowIndex + 1)}
      </span>
    ),
  },
  {
    dataField: "first_name",
    text: "Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row.first_name}
      </span>
    ),
  },
  {
    dataField: "middle_name",
    text: "Middle Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.middle_name}
      </span>
    ),
  },
  {
    dataField: "last_name",
    text: "Last Name",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.last_name}
      </span>
    ),
  },

  {
    dataField: "email1",
    text: "Email",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.email1 || "--"}
      </span>
    ),
  },
  {
    dataField: "feedback_id",
    text: "Feedback Id",
    formatter: (_, row) => (
      <span className="text-capitalize cursor-pointer">{row?.id}</span>
    ),
  },
  {
    dataField: "step1",
    text: "Step 1",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step1 === 1 ? "Completed" : row?.step1 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step2",
    text: "Step 2",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step2 === 1 ? "Completed" : row?.step2 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step3",
    text: "Step 3",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step3 === 1 ? "Completed" : row?.step3 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step4",
    text: "Step 4",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step4 === 1 ? "Completed" : row?.step4 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step5",
    text: "Step 5",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step5 === 1 ? "Completed" : row?.step5 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step6",
    text: "Step 6",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step6 === 1 ? "Completed" : row?.step6 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step7",
    text: "Step 7",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step7 === 1 ? "Completed" : row?.step7 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    dataField: "step8",
    text: "Step 8",
    formatter: (_, row) => (
      <span
        onClick={() => onCliclNavigate(row?.id)}
        className="text-capitalize cursor-pointer hover-lightblue"
      >
        {row?.step8 === 1 ? "Completed" : row?.step8 === 0 ? "Pending" : "--"}
      </span>
    ),
  },
  {
    text: "Created At",
    dataField: "createdAt",
    formatter: (_, row) => DATE_FORMAT(row.createdAt),
  },
];
export default Columns;
